import DispensaryHeaderDesktop from './dispensary-header-desktop';
import DispensaryHeaderMobile from './dispensary-header-mobile';

export { DispensaryHeaderDesktop, DispensaryHeaderMobile };
